(($) => {
	$(window).on("load", () => {
		window.FX = window.FX || {};
		window.FX.CanadaCheck = new CanadaCheck();
	});

	class CanadaCheck {
		constructor() {
			// this.ip 				= null
			// this.closedPopup 		= false

			this.storageKeyIPLookupData = "webfx_ip_country_data";

			this.$elFlag = $(".js-canada-flag");
			this.$elPopup = $(".js-canada-popup");
			this.$elPopupOverlay = $(".js-canada-popup-overlay");

			this.init();
			this.bind();
		}

		async init() {
			// this.ip 			= this.getValueFromLocalStorage( 'ip' )
			// this.closedPopup 	= this.getValueFromLocalStorage( 'closedPopup', false )

			// if( !this.country ) {
			// 	const { ip, country } = await this.fetchIPCountryData()

			// 	this.ip 		= ip
			// 	this.country	= country

			// 	this.setIPCountryData()
			// }

			if (await this.isCanada() && !this.getPopUpClosedByUser()) {
				$(".price span").fadeOut(); //hidden always and showing when we are not in canada.
				$(
					"span.product-price.product__price--original.text-size--large"
				).fadeOut();
				$(".cart-functions").fadeOut();
				$(
					".cart-item .content .item-price, .search-results.predictive-search .search-item .content .item-price"
				).fadeOut();
				$("head").append(
					'<style type="text/css">.search-item .item-price{display:none !important;}</style>'
				);

				// this.showFlag();
				this.showPopup();
				// if( true !== this.closedPopup ) {
				// 	this.showPopup()
				// }

				// if(window.location.href === "https://resourcefurniture.com/pages/resource-furniture-canada"){
				//     this.closedPopup = true

				// 	this.setIPCountryData()

				// 	this.hidePopup()
				// }

				$(".canada-button-new").show();
				$("#Filter-Instock").on("click", function () {
					setTimeout(() => {
						$(".canada-button-new").show();
					}, 1000);
				});
			} else {
				// $('.price span').fadeIn(); //hidden always and showing when we are not in canada.
				// $('span.product-price.product__price--original.text-size--large').fadeIn();
				$(".cart-functions").fadeIn();
				// $('.cart-item .content .item-price, .search-results.predictive-search .search-item .content .item-price').fadeIn();
				// $('.search-item item-price').fadeIn();
				// $('#Filter-Instock').on('click', function() {
				//     setTimeout(() => {
				//       $('.price span').show();
				//     }, 1000);
				// })
			}
		}

		bind() {
			this.$elPopup
				.find(".popup-close")
				.on("click", this.handleClosePopup.bind(this));
			this.$elPopup
				.find(".js-canada-popup a")
				.on("click", this.handleClosePopup.bind(this));
		}

		handleClosePopup() {
			// this.closedPopup = true

			// this.setIPCountryData()

			this.hidePopup();
			this.setPopUpClosedByUser(true);
		}
		async isCanada() {
			const country = await this.getCountry();
			return (
				"CA" === country || new URLSearchParams(window.location.search).has("fx-debug-canada")
			);
		}
		async getCountry() {
			let data = this.getValueFromLocalStorage(this.storageKeyIPLookupData);
			data = JSON.parse(data);
			if (data && data.country) {
				return data.country;
			}
			const { ip, country } = await this.fetchIPCountryData();
			this.setIPCountryData(ip, country);
			return country;
		}
		fetchIPCountryData() {
			return new Promise((resolve) => {
				$.get("https://ipinfo.io/json?token=319efd1ea0bbff", (res) => {
					resolve({
						ip: res.ip,
						country: res.country,
					});
				});
			});
		}
		getPopUpClosedByUser() {
			return sessionStorage.getItem("popupClosedByUser") ?? false;
		}
		setPopUpClosedByUser(value) {
			sessionStorage.setItem("popupClosedByUser", value);
		}
		setIPCountryData(ip, country) {
			const data = {
				ip: ip,
				country: country,
				// closedPopup: 	this.closedPopup,
			};
			window.localStorage.setItem(
				this.storageKeyIPLookupData,
				JSON.stringify(data)
			);
		}
		getValueFromLocalStorage(key, defaultValue = null) {
			if (window.localStorage) {
				const data = window.localStorage.getItem(this.storageKeyIPLookupData);
				return data;
			}
			return defaultValue;
		}
		showFlag() {
			this.$elFlag.show();
		}

		showPopup() {
			this.$elPopup.show();
			this.$elPopupOverlay.show();
		}

		hidePopup() {
			this.$elPopup.fadeOut();
			this.$elPopupOverlay.fadeOut();
		}
	}
})(jQuery);
